import { supabase } from '../supabase.js'
import { readBreadthSnapshot } from './breadthContract.js'

export async function fetchBreadthSnapshot({ signal } = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error('Sign in to view breadth data')
  const response = await fetch('/api/market-regime/breadth', {
    headers: { Authorization: `Bearer ${session.access_token}` }, signal,
  })
  if (![200, 503].includes(response.status)) throw new Error('Breadth data is unavailable')
  const snapshot = readBreadthSnapshot(await response.json())
  if (!response.ok) snapshot.usable = snapshot.actionable = false
  return snapshot
}

export async function streamBreadthSnapshots({signal,onSnapshot,onCurrent,retained}) {
  const {data:{session}}=await supabase.auth.getSession()
  if(!session?.access_token)throw new Error('Sign in required')
  let revision=retained?.snapshot&&/^[a-f0-9]{64}$/.test(retained.revision||'')?retained.revision:null
  const response=await fetch(`/api/market-regime/breadth-stream${revision?`?revision=${revision}`:''}`,{
    headers:{Authorization:`Bearer ${session.access_token}`,Accept:'text/event-stream'},signal,
  })
  if(!response.ok||!response.headers.get('content-type')?.includes('text/event-stream')||!response.body)throw new Error('Breadth stream unavailable')
  const reader=response.body.getReader(),decoder=new TextDecoder()
  let buffer='',received=false
  try {
    while(true){
      const {value,done}=await reader.read();if(done)break
      buffer=(buffer+decoder.decode(value,{stream:true})).replace(/\r\n/g,'\n')
      if(buffer.length>4_000_000)throw new Error('Invalid Breadth stream size')
      let boundary
      while((boundary=buffer.indexOf('\n\n'))!==-1){
        const frame=buffer.slice(0,boundary);buffer=buffer.slice(boundary+2)
        if(frame.split('\n').includes('event: unavailable'))throw new Error('Breadth feed interrupted')
        const current=frame.split('\n').includes('event: breadth-current')
        if(!current&&!frame.split('\n').includes('event: breadth'))continue
        const body=frame.split('\n').filter(line=>line.startsWith('data:')).map(line=>line.slice(5).trimStart()).join('\n')
        if(current){
          if(!revision||JSON.parse(body).revision!==revision)throw new Error('Unknown breadth revision')
          received=true;onCurrent?.();continue
        }
        const snapshot=readBreadthSnapshot(JSON.parse(body))
        const id=frame.split('\n').find(line=>line.startsWith('id:'))?.slice(3).trim()
        revision=/^[a-f0-9]{64}$/.test(id||'')?id:null
        received=true
        // Accept an older server's frames without IDs; they simply cannot resume.
        if(revision)onSnapshot(snapshot,revision);else onSnapshot(snapshot)
      }
    }
    if(!received)throw new Error('No Breadth snapshot')
  } finally {await reader.cancel().catch(()=>{});reader.releaseLock()}
}
